import { useContext } from "react";
import { SMSContext, SMSContextType } from "@/providers/SMSProvider";

export function useSMS(): SMSContextType {
  const context = useContext(SMSContext);

  if (!context) {
    throw new Error("useSMS must be used within an SMSProvider");
  }

  return context;
}
